export default "__VITE_ASSET__BMGYchDc__"